import { action } from "satcheljs";
import type { ActionSource } from "owa-mail-store";

/**
 * Action to select the default folder when a shared folder user is removed.
 * @param actionSource Source from where this action is called.
 *
 */
export interface SELECT_DEFAULT_FOLDERActionMessage {
    actionSource: ActionSource;
}
export const selectDefaultFolderOnRemove: (actionSource: ActionSource) => SELECT_DEFAULT_FOLDERActionMessage = action("SELECT_DEFAULT_FOLDER", (actionSource: ActionSource): SELECT_DEFAULT_FOLDERActionMessage => {
    return {
        actionSource,
    };
});
